import { graphql } from 'react-relay';

import { modulesNamesFragment } from './__generated__/modulesNamesFragment.graphql';

// eslint-disable-next-line
graphql`
  fragment modulesNamesFragment on Company {
    preferences {
      feedback {
        module {
          name
          pluralName
        }
      }
      feedbackOneToOne {
        module {
          name
        }
      }
    }
  }
`;

export const getFeedbackModuleName = (company: modulesNamesFragment) =>
  company?.preferences?.feedback?.module?.name || 'Feedback';

export const getFeedbackModulePluralName = (company: modulesNamesFragment) =>
  company?.preferences?.feedback?.module?.pluralName || 'Feedbacks';

export const getFeedbackOneToOneModuleName = (company: modulesNamesFragment) =>
  company?.preferences?.feedbackOneToOne?.module?.name || '1a1';
